import React, { ChangeEvent, Component } from "react";
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Localization from "data/localization-sensoan/Localization";

interface Props {
  searchString: string;
  className: string;
  onSearchTriggered: (searchString: string) => void;
}

interface State {
  searchString: string;
}

export default class SearchBar extends Component<Props, State> {

  public constructor(props: Props) {
    super(props);
    this.state = {
      searchString: props.searchString,
    };
  }

  private handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === "Enter") {
      this.triggerSearch();
    }
  };

  private triggerSearch = (): void => {
    this.props.onSearchTriggered(this.state.searchString);
  };

  public render(): JSX.Element {
    return (
      <div className={this.props.className}>
        <FormControl variant="outlined" fullWidth={true}>
          <InputLabel>{Localization.getInstance().getDisplayText("Actions", "search")}</InputLabel>
          <OutlinedInput
            type="text"
            value={this.state.searchString}
            onChange={(event: ChangeEvent<HTMLInputElement>): void =>
              this.setState({ searchString: event.target.value })}
            onKeyPress={this.handleKeyPress}
            endAdornment={
              <InputAdornment position="end">
                <IconButton type="submit" aria-label="search" onClick={this.triggerSearch}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
            labelWidth={70}
          />
        </FormControl>
      </div>
    );
  }
}
